import React, { useState } from 'react';
import styled from 'astroturf/react';
import type { Props } from './AdminBar';
import { Icon } from 'js/design_system/Icon';
import _ActivatorButtonContainer from "AdminBarActivator-ActivatorButtonContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/admin_bar/AdminBarActivator.tsx?styleId=ActivatorButtonContainer";
import _LoadingButtonContainer from "AdminBarActivator-LoadingButtonContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/admin_bar/AdminBarActivator.tsx?styleId=LoadingButtonContainer";


// Lazy load AdminBar component with code-splitting
const AdminBar = React.lazy(
  () => import(/* webpackChunkName: "admin-bar" */ './AdminBar'),
);

const AdminBarActivator: React.FC<Props> = (props) => {
  const [isActivated, setIsActivated] = useState(props.openByDefault);

  // Only show for admin users
  if (!props.admin) {
    return null;
  }

  // If activated, render the lazy AdminBar with Suspense
  if (isActivated) {
    return (
      <React.Suspense fallback={<LoadingButton />}>
        <AdminBar {...props} openByDefault={true} />
      </React.Suspense>
    );
  }

  // Otherwise, show activator button
  return <ActivatorButton onClick={() => setIsActivated(true)} />;
};

// Styled components (copied from AdminBar.tsx for consistency)
const ActivatorButtonContainer = /*#__PURE__*/styled("button", null, {
  displayName: "ActivatorButtonContainer",
  styles: _ActivatorButtonContainer
});

const LoadingButtonContainer = /*#__PURE__*/styled(ActivatorButtonContainer, null, {
  displayName: "LoadingButtonContainer",
  styles: _LoadingButtonContainer
});

const ActivatorButton: React.FC<React.ComponentPropsWithoutRef<'button'>> = (
  props,
) => (
  <ActivatorButtonContainer {...props}>
    <Icon name="admin_panel_settings" size={24} />
  </ActivatorButtonContainer>
);

const LoadingButton: React.FC = () => (
  <LoadingButtonContainer disabled title="Loading Admin Panel...">
    <Icon name="hourglass_empty" size={24} />
  </LoadingButtonContainer>
);

export default AdminBarActivator;
